<template>
  <v-navigation-drawer
    v-model="drawer"
    expand-on-hover
    permanent
    touchless
    fixed
    app
    width="300px"
    mini-variant-width="56"
    color="primary"
    class="no-scrollbar"
  >
    <v-toolbar color="primary darken-1" class="v-toolbar__app drawer-logo-toolbar" dark>
      <div class="drawer-logo-wrap d-inline-flex align-center">
        <!-- N-07: logo del dealer/grupo (o el por defecto de PivotFleet) con object-fit:contain para no recortar logos rectangulares (p. ej. "PIVOT FLEET"). En mini se escala al ancho disponible, en expandido crece hasta 96px. -->
        <img
          :src="avatar"
          alt="Logo"
          class="drawer-logo-img"
          :title="dealer"
        />
        <span class="pl-2 title drawer-title-text">
          {{ dealer }}
        </span>
      </div>
    </v-toolbar>

    <v-list nav dense :key="menuKey">
      <template v-for="(item, i) in menu">
        <!-- división -->
        <v-divider v-if="item.divider" :key="i"></v-divider>

        <!-- grupo desplegable -->
        <v-list-group
          v-else-if="item.items"
          :key="item.name"
          :value="isGroupCurrent(item)"
          :class="{ 'v-list-group--current': isGroupCurrent(item) }"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="22" color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="color: white; font-size: medium;">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.name"
            :to="{ name: subItem.name }"
            exact
            active-class="v-list-item--active"
          >
            <!-- <v-list-item-icon>
              <v-icon size="18" color="white">{{ subItem.icon || 'mdi-circle-small' }}</v-icon>
            </v-list-item-icon> -->
            <v-list-item-content>
              <v-list-item-title style="color: white; font-size: 14px;">{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- enlace directo -->
        <v-list-item
          v-else
          :key="item.name + '-item'"
          :to="!item.href && !item.isChatbot ? { name: item.name } : null"
          :href="item.href"
          :disabled="item.disabled"
          :target="item.target"
          :input-value="isActive(item) && !item.isChatbot"
          active-class="v-list-item--active"
          exact
          rel="noopener"
          @click="item.isChatbot && $emit('toggle-chatbot')"
        >
          <v-list-item-icon>
            <v-icon size="22" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: white; font-size: medium;">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>

      <!-- Botón de Facturación (movido al final) -->
      <v-divider class="my-3" v-if="showBilling"></v-divider>
      <v-list-item
        key="billing-portal"
        v-if="showBilling"
        @click="openBillingPortal"
      >
        <v-list-item-icon>
          <v-icon size="22" style="color: white;">mdi-credit-card</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white; font-size: medium;">Facturación</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Información de Soporte -->
      <v-divider class="my-3"></v-divider>
      <v-list-item key="support-info">
        <v-list-item-icon>
          <v-icon size="22" style="color: white;">mdi-help-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: white; font-size: medium; font-weight: bold;">
            ¿Necesitas ayuda?
          </v-list-item-title>
          <v-list-item-subtitle style="color: rgba(255,255,255,0.8); font-size: small;">
            Escríbenos al email<br>
            <div class="d-flex align-center">
              <span 
                style="color: white; text-decoration: underline; cursor: pointer; font-size: medium;"
                @click.stop="openEmailClient"
              >
                soporte@pivotfleet.com
              </span>
              <v-icon 
                size="16" 
                style="color: rgba(255,255,255,0.7); margin-left: 8px; cursor: pointer;"
                @click.stop="copyEmailToClipboard"
                title="Copiar email"
              >
                mdi-content-copy
              </v-icon>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import menuConfig from '../config/menu'
import menuColaboratorConfig from '../config/menu_colaborator'
import menuGrupoConfig from '../config/menu_grupo'
import UserService from '@/services/UserService'
import store from '../../store'

export default {
  name: 'app-drawer',

  data: () => ({
    drawer: true,
    billingUrl: null
  }),

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component
        }
      }
      return { name: `${item.group}/${(subItem.name)}` }
    },

    async loadBillingUrl () {
      try {
        if (!this.showBilling) {
          return
        }
        let response = await UserService.getBillingPortal()
        this.billingUrl = response.data.data.url
      } catch (error) {
        console.error('Error al obtener la URL de facturación:', error)
      }
    },

    openBillingPortal () {
      if (this.billingUrl) {
        window.open(this.billingUrl, '_blank')
      } else {
        this.$toast.error('No se pudo obtener la URL de facturación')
      }
    },

    openEmailClient () {
      const email = 'soporte@pivotfleet.com'
      const subject = 'Solicitud de soporte - PivotFleet'
      const body = 'Hola,%0D%0A%0D%0ANecesito ayuda con:%0D%0A%0D%0A(Describe tu problema aquí)%0D%0A%0D%0AGracias.'
      const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${body}`
      window.location.href = mailtoLink
    },

    async copyEmailToClipboard () {
      try {
        const email = 'soporte@pivotfleet.com'
        await navigator.clipboard.writeText(email)
        this.$toast.success('Email copiado al portapapeles')
      } catch (error) {
        // Fallback para navegadores que no soportan clipboard API
        const textArea = document.createElement('textarea')
        textArea.value = 'soporte@pivotfleet.com'
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
          this.$toast.success('Email copiado al portapapeles')
        } catch (fallbackError) {
          this.$toast.error('No se pudo copiar el email')
        }
        document.body.removeChild(textArea)
      }
    },

    // El grupo contiene la vista actual: se abre y se resalta como las demás entradas
    isGroupCurrent (item) {
      return item.items.some(sub => sub.name === this.$route.name)
    },

    isActive (item) {
      // Verifica si la ruta actual coincide con la ruta del elemento del menú
      return this.$route.name === item.name ||
             (item.group && this.$route.path.startsWith(item.group))
    },

    // Método para verificar si el usuario tiene al menos un rol o permiso del array
    hasAnyRoleOrPermission (items) {
      if (!items || !Array.isArray(items)) {
        return false
      }
      
      // Verificar si tiene alguno de los roles
      if (this.$store.getters.HAS_ROLE(items)) {
        return true
      }
      
      // Verificar si tiene alguno de los permisos
      return items.some(item => this.$store.getters.HAS_PERMISSION(item))
    }
  },

  computed: {
    menu () {
      // Administrador de Grupo en su panel: menú del Entorno Grupo
      if (this.$store.getters.IS_GROUP_ADMIN) {
        return menuGrupoConfig
      }
      // Si el usuario tiene rol colaborator, usar el menú colaborador
      if (this.$store.getters.HAS_ROLE(['colaborator'])) {
        return menuColaboratorConfig.filter(el => {
          // Si no hay roles definidos, mostrar el elemento (acceso público)
          if (!el.roles) {
            // Verificar si está excluido por excludeRoles
            if (el.excludeRoles && this.$store.getters.HAS_ROLE(el.excludeRoles)) {
              return false
            }
            return true
          }
          
          // Si hay roles definidos, verificar si el usuario los tiene
          const hasRequiredRoles = this.hasAnyRoleOrPermission(el.roles)
          
          // Si no tiene los roles requeridos, no mostrar
          if (!hasRequiredRoles) {
            return false
          }
          
          // Si tiene los roles requeridos, verificar si está excluido por excludeRoles
          if (el.excludeRoles && this.$store.getters.HAS_ROLE(el.excludeRoles)) {
            return false
          }
          
          // Si pasa todas las verificaciones, mostrar el elemento
          return true
        })
      }
      // Si no, usar el menú normal
      // return menuConfig.filter(el => !el.roles || (el.roles && this.$store.getters.HAS_ROLE(el.roles)))
      return menuConfig.filter(el => {
        // Si no hay roles definidos, mostrar el elemento (acceso público)
        if (!el.roles) {
          // Verificar si está excluido por excludeRoles
          if (el.excludeRoles && this.$store.getters.HAS_ROLE(el.excludeRoles)) {
            return false
          }
          return true
        }
        
        // Si hay roles definidos, verificar si el usuario los tiene
        const hasRequiredRoles = this.hasAnyRoleOrPermission(el.roles)
        
        // Si no tiene los roles requeridos, no mostrar
        if (!hasRequiredRoles) {
          return false
        }
        
        // Si tiene los roles requeridos, verificar si está excluido por excludeRoles
        if (el.excludeRoles && this.$store.getters.HAS_ROLE(el.excludeRoles)) {
          return false
        }
        
        // Si pasa todas las verificaciones, mostrar el elemento
        return true
      })
    },
    
    // La facturación es del Manager titular; no se muestra al Administrador de Grupo dentro de un dealer
    showBilling () {
      return this.$store.getters.HAS_ROLE(['manager']) &&
        !this.$store.getters.HAS_ROLE(['colaborator']) &&
        !this.$store.getters.ACTING_DEALER_ID
    },

    menuKey () {
      // Forzar recarga del menú cuando cambian roles o permisos
      return JSON.stringify(this.$store.getters.CURRENT_USER_ROLES) + JSON.stringify(this.$store.getters.CURRENT_USER_PERMISSIONS)
    },
    avatar () {
      if (localStorage.getItem('logo')) {
        return JSON.parse(localStorage.getItem('logo')).url
      } else {
        return require('@/assets/logo.png')
      }
    },
    dealer () {
      const user = this.$store.getters.CURRENT_USER
      const name = user.dealer ? user.dealer.name : (user.grupo && this.$store.getters.IS_GROUP_ADMIN ? user.grupo.name : null)
      if (name) {
        return name.length > 14 ? name.slice(0, 14) + '...' : name
      }
      return 'PivotFleet'
    }
  },

  created () {
    const isLoggedIn = store.getters.LOGGED_IN
    if (isLoggedIn) {
      this.loadBillingUrl()
    }
  }
}
</script>
<style>
.no-scrollbar ::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;  /* IE y Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Cabecera del grupo resaltada cuando la vista actual está dentro (visible también con el menú contraído) */
.v-list-group--current > .v-list-group__header.v-list-item--active:not(:hover):not(:focus)::before,
.v-list-group--current .v-list-group__items .v-list-item--active::before {
  background-color: rgba(0, 0, 0, 0.87);
  opacity: 0.12;
}

/* N-07: logo del dealer/grupo sin recortes y sin texto cortado.
   - En el drawer EXPANDIDO: el logo crece hasta 96px y aparece el texto del dealer al lado.
   - En el drawer COLAPSADO (mini-variant, 56px): el logo se centra y se escala al ancho mini
     (hasta 44px, dejando ~6px de aire a cada lado), y el texto del dealer se oculta en vez
     de aparecer cortado ("AN..."). !important para ganar a reglas anchas de Vuetify. */
.drawer-logo-toolbar .v-toolbar__content {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.drawer-logo-wrap {
  width: 100%;
  min-width: 0;
}
.drawer-logo-img {
  height: 48px !important;
  max-width: 96px !important;
  width: auto !important;
  object-fit: contain !important;
  display: block !important;
  flex-shrink: 0;
}
.drawer-title-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-navigation-drawer--mini-variant .drawer-logo-img {
  max-width: 44px !important;
  margin: 0 auto !important;
}
.v-navigation-drawer--mini-variant .drawer-title-text {
  display: none !important;
}
.v-navigation-drawer--mini-variant .drawer-logo-wrap {
  justify-content: center;
}
</style>
